// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@page {
  size: auto;
}
.certificateDiv {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.newCertificateCard {
  border-radius: var(--border-radius-large);
  height: 100%;
  margin: 0;
}
.newCertificateCard ion-card-content {
  padding: var(--spacing-small);
}

ion-grid {
  padding-left: var(--spacing-small);
  padding-right: var(--spacing-small);
  padding-top: var(--spacing-xx-small);
  padding-bottom: var(--spacing-xx-small);
}

ion-col {
  padding: var(--spacing-xx-small);
  display: flex;
  align-items: center;
  justify-content: center;
  height: auto;
}

ion-input.certificateInput {
  width: 100%;
  font-size: var(--font-size-small);
}
ion-input.certificateInput ::ng-deep .label-text-wrapper.sc-ion-input-md .label-text.sc-ion-input-md {
  opacity: 0.8;
}

ion-scroll {
  height: 100%;
}

.select-popover {
  font-size: var(--font-size-small);
}

.save-certificate-button,
.update-certificate-button {
  width: 50%;
  border-radius: var(--border-radius-large);
  font-size: var(--font-size-small);
  margin: auto;
  align-self: center;
  justify-self: center;
}
.save-certificate-button::part(native),
.update-certificate-button::part(native) {
  padding: var(--spacing-xx-small);
}

.certificateCard {
  border-radius: var(--border-radius-large);
  height: 100%;
  display: flex;
  flex-direction: column;
  margin: 0;
}
.certificateCard ion-card-header {
  padding: var(--spacing-small) var(--spacing-medium);
  font-size: var(--font-size-medium);
}
.certificateCard ion-card-content {
  padding-bottom: 0;
  display: flex;
  flex-direction: column;
  flex: 1;
}
.certificateCard ion-card-content p {
  font-size: var(--font-size-small);
  margin: 0;
}

.certificateButtonsDiv {
  display: flex;
  justify-content: center;
  align-self: center;
  margin: var(--spacing-small);
  margin-top: auto;
}

.certificateButton {
  font-size: var(--font-size-small);
}

/** Media queries to set font size and spacing based on screen size **/
/*#region Small Screens*/
/* Styles for screens smaller than 800px wide or 550 high */
@media (max-width: 599px) {
  ion-row {
    min-height: 40px;
  }
  ion-select.select-popover,
  ion-input.certificateInput {
    height: 34px;
    min-height: 34px;
  }
  ion-input.certificateInput {
    font-size: var(--font-size-medium);
  }
  .save-certificate-button,
  .update-certificate-button,
  .certificateButton {
    --min-height: 28px;
    min-height: 28px;
    height: 28px;
  }
  .save-certificate-button::part(native),
  .update-certificate-button::part(native),
  .certificateButton::part(native) {
    min-height: 28px;
    height: 28px;
  }
  .certificateCard ion-card-header {
    padding: var(--spacing-medium) var(--spacing-large);
  }
}
/*#endregion Small Screens*/
/*#region Medium Screens*/
/* Styles for medium screens with min with of 800px and min height of 550px */
@media (min-width: 600px) and (max-width: 1023px) {
  ion-row {
    min-height: 48px;
  }
  ion-select.select-popover,
  ion-input.certificateInput {
    height: 40px;
    min-height: 40px;
  }
  .save-certificate-button,
  .update-certificate-button,
  .certificateButton {
    --min-height: 32px;
    height: 32px;
  }
  .save-certificate-button::part(native),
  .update-certificate-button::part(native),
  .certificateButton::part(native) {
    min-height: 32px;
    height: 32px;
  }
}
/*#endregion Medium Screens*/
/*#region Larger Screens*/
/* Styles for screens larger than 1000px wide and 600px high */
@media (min-width: 1024px) {
  ion-row {
    min-height: 56px;
  }
  ion-select.select-popover,
  ion-input.certificateInput {
    height: 48px;
    min-height: 48px;
  }
  .save-certificate-button,
  .update-certificate-button,
  .certificateButton {
    --min-height: 36px;
    height: 36px;
  }
  .save-certificate-button::part(native),
  .update-certificate-button::part(native),
  .certificateButton::part(native) {
    min-height: 36px;
    height: 36px;
  }
}
/*#endregion Larger Screens*/`, "",{"version":3,"sources":["webpack://./src/app/pages/pilot-form/pilot-form-components/pilot-certificate/pilot-certificate.component.scss"],"names":[],"mappings":"AAAA;EACI,UAAA;AACJ;AAEE;EACE,aAAA;EACA,sBAAA;EACA,YAAA;AAAJ;;AAGE;EACE,yCAAA;EACA,YAAA;EACA,SAAA;AAAJ;AACI;EACE,6BAAA;AACN;;AAGE;EACE,kCAAA;EACA,mCAAA;EACA,oCAAA;EACA,uCAAA;AAAJ;;AAGE;EACE,gCAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;AAAJ;;AAGE;EACE,WAAA;EACA,iCAAA;AAAJ;AAGM;EACE,YAAA;AADR;;AAME;EACE,YAAA;AAHJ;;AAME;EACE,iCAAA;AAHJ;;AAME;;EAEE,UAAA;EACA,yCAAA;EACA,iCAAA;EACA,YAAA;EACA,kBAAA;EACA,oBAAA;AAHJ;AAII;;EACE,gCAAA;AADN;;AAKE;EACE,yCAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;AAFJ;AAGI;EACE,mDAAA;EACA,kCAAA;AADN;AAGI;EACE,iBAAA;EACA,aAAA;EACA,sBAAA;EACA,OAAA;AADN;AAEM;EACE,iCAAA;EACA,SAAA;AAAR;;AAKE;EACE,aAAA;EACA,uBAAA;EACA,kBAAA;EACA,4BAAA;EACA,gBAAA;AAFJ;;AAKE;EACE,iCAAA;AAFJ;;AAKE,sEAAA;AAEA,wBAAA;AAEA,2DAAA;AACA;EACE;IACE,gBAAA;EAJJ;EAOE;;IAEE,YAAA;IACA,gBAAA;EALJ;EAQE;IACE,kCAAA;EANJ;EASE;;;IAGE,kBAAA;IACA,gBAAA;IACA,YAAA;EAPJ;EAQI;;;IACE,gBAAA;IACA,YAAA;EAJN;EASI;IACE,mDAAA;EAPN;AACF;AAWE,2BAAA;AAEA,yBAAA;AAEA,6EAAA;AACA;EACE;IACE,gBAAA;EAXJ;EAcE;;IAEE,YAAA;IACA,gBAAA;EAZJ;EAeE;;;IAGE,kBAAA;IACA,YAAA;EAbJ;EAcI;;;IACE,gBAAA;IACA,YAAA;EAVN;AACF;AAcE,4BAAA;AAEA,yBAAA;AAEA,8DAAA;AACA;EACE;IACE,gBAAA;EAdJ;EAiBE;;IAEE,YAAA;IACA,gBAAA;EAfJ;EAkBE;;;IAGE,kBAAA;IACA,YAAA;EAhBJ;EAiBI;;;IACE,gBAAA;IACA,YAAA;EAbN;AACF;AAiBE,4BAAA","sourcesContent":["@page{\r\n    size: auto;\r\n  }\r\n\r\n  .certificateDiv {\r\n    display: flex;\r\n    flex-direction: column;\r\n    height: 100%;\r\n  }\r\n\r\n  .newCertificateCard {\r\n    border-radius: var(--border-radius-large);\r\n    height: 100%;\r\n    margin: 0;\r\n    ion-card-content {\r\n      padding: var(--spacing-small);\r\n    }\r\n  }\r\n\r\n  ion-grid {\r\n    padding-left: var(--spacing-small);\r\n    padding-right: var(--spacing-small);\r\n    padding-top: var(--spacing-xx-small);\r\n    padding-bottom: var(--spacing-xx-small);\r\n  }\r\n\r\n  ion-col {\r\n    padding: var(--spacing-xx-small);\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    height: auto;\r\n  }\r\n\r\n  ion-input.certificateInput {\r\n    width: 100%;\r\n    font-size: var(--font-size-small);\r\n\r\n    ::ng-deep .label-text-wrapper.sc-ion-input-md {\r\n      .label-text.sc-ion-input-md {\r\n        opacity: 0.8;\r\n      }\r\n    }\r\n  }\r\n\r\n  ion-scroll {\r\n    height: 100%;\r\n  }\r\n\r\n  .select-popover {\r\n    font-size: var(--font-size-small);\r\n  }\r\n\r\n  .save-certificate-button,\r\n  .update-certificate-button {\r\n    width: 50%;\r\n    border-radius: var(--border-radius-large);\r\n    font-size: var(--font-size-small);\r\n    margin: auto;\r\n    align-self: center;\r\n    justify-self: center;\r\n    &::part(native) {\r\n      padding: var(--spacing-xx-small);\r\n    }\r\n  }\r\n\r\n  .certificateCard {\r\n    border-radius: var(--border-radius-large);\r\n    height: 100%;\r\n    display: flex;\r\n    flex-direction: column;\r\n    margin: 0;\r\n    ion-card-header {\r\n      padding: var(--spacing-small) var(--spacing-medium);\r\n      font-size: var(--font-size-medium);\r\n    }\r\n    ion-card-content {\r\n      padding-bottom: 0;\r\n      display: flex;\r\n      flex-direction: column;\r\n      flex: 1;\r\n      p {\r\n        font-size: var(--font-size-small);\r\n        margin: 0;\r\n      }\r\n    }\r\n  }\r\n\r\n  .certificateButtonsDiv {\r\n    display: flex;\r\n    justify-content: center;\r\n    align-self: center;\r\n    margin: var(--spacing-small);\r\n    margin-top: auto;\r\n  }\r\n\r\n  .certificateButton {\r\n    font-size: var(--font-size-small);\r\n  }\r\n\r\n  /** Media queries to set font size and spacing based on screen size **/\r\n\r\n  /*#region Small Screens*/\r\n\r\n  /* Styles for screens smaller than 800px wide or 550 high */\r\n  @media (max-width: 599px) {\r\n    ion-row {\r\n      min-height: 40px;\r\n    }\r\n\r\n    ion-select.select-popover,\r\n    ion-input.certificateInput {\r\n      height: 34px;\r\n      min-height: 34px;\r\n    }\r\n\r\n    ion-input.certificateInput {\r\n      font-size: var(--font-size-medium);\r\n    }\r\n\r\n    .save-certificate-button,\r\n    .update-certificate-button,\r\n    .certificateButton {\r\n      --min-height: 28px;\r\n      min-height: 28px;\r\n      height: 28px;\r\n      &::part(native) {\r\n        min-height: 28px;\r\n        height: 28px;\r\n      }\r\n    }\r\n\r\n    .certificateCard {\r\n      ion-card-header {\r\n        padding: var(--spacing-medium) var(--spacing-large);\r\n      }\r\n    }\r\n  }\r\n\r\n  /*#endregion Small Screens*/\r\n\r\n  /*#region Medium Screens*/\r\n\r\n  /* Styles for medium screens with min with of 800px and min height of 550px */\r\n  @media (min-width: 600px) and (max-width: 1023px) {\r\n    ion-row {\r\n      min-height: 48px;\r\n    }\r\n\r\n    ion-select.select-popover,\r\n    ion-input.certificateInput {\r\n      height: 40px;\r\n      min-height: 40px;\r\n    }\r\n\r\n    .save-certificate-button,\r\n    .update-certificate-button,\r\n    .certificateButton {\r\n      --min-height: 32px;\r\n      height: 32px;\r\n      &::part(native) {\r\n        min-height: 32px;\r\n        height: 32px;\r\n      }\r\n    }\r\n  }\r\n\r\n  /*#endregion Medium Screens*/\r\n\r\n  /*#region Larger Screens*/\r\n\r\n  /* Styles for screens larger than 1000px wide and 600px high */\r\n  @media (min-width: 1024px) {\r\n    ion-row {\r\n      min-height: 56px;\r\n    }\r\n\r\n    ion-select.select-popover,\r\n    ion-input.certificateInput {\r\n      height: 48px;\r\n      min-height: 48px;\r\n    }\r\n\r\n    .save-certificate-button,\r\n    .update-certificate-button,\r\n    .certificateButton {\r\n      --min-height: 36px;\r\n      height: 36px;\r\n      &::part(native) {\r\n        min-height: 36px;\r\n        height: 36px;\r\n      }\r\n    }\r\n  }\r\n\r\n  /*#endregion Larger Screens*/\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
